import TitanDataWhiteIco from "../assets/icons/TitanDataWhiteIco";
import TitanDataBlackIco from "../assets/icons/TitanDataBlackIco";

export const platformWhiteLogo = (props = {}) => {
  const { width = "129", height = "40" } = props;
  return <TitanDataWhiteIco width={width} height={height} />;
};

export const platformBlackLogo = (props = {}) => {
  const { width = "129", height = "40" } = props;
  return <TitanDataBlackIco width={width} height={height} />;
};